import { AnnouncementsService } from "@/services/announcements/announcements.service";

const _announcementsService = new AnnouncementsService();

const saveAnnoucementAction = ({ commit }, { type, id, data, callback }) => {
  _announcementsService
    .saveAnnouncements(type, id, data)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error);
    });
};

const getAnnouncementsAction = ({ commit }, { type, id, callback }) => {
  _announcementsService
    .getAnnouncements(type, id)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error);
    });
};
const deleteAnnouncementAction = ({ commit }, { id, callback }) => {
  _announcementsService
    .deleteAnnouncements(id)
    .then((response) => {
      callback(response);
    })
    .catch((error) => {
      console.log(error);
    });
};
export default {
  saveAnnoucementAction,
  getAnnouncementsAction,
  deleteAnnouncementAction,
};
